module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp23_1.0809b149.png";